import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  inject,
} from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { UrlHandlingStrategy, provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { CheckInvalidEventPlugin } from '@offconon/shared/util/check-invalid-form-plugin';
import { provideEffects } from '@ngrx/effects';
import { provideStore, ActionReducer, MetaReducer } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EnvironmentService } from '@offconon/shared/utils/services/environment';
import { SharedUtilsTranslateModule } from '@offconon/shared/utils/translate';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { theme } from '@offconon/shared/ui/theme-switch';
import { DomainUrlHandlingStrategy } from './utils/domain-url-handling-strategy.service';
import { localStorageSync } from 'ngrx-store-localstorage';

import { authInterceptor } from './utils/auth.interceptor';
import { GlobalHttpErrorInterceptor } from '../../../../libs/shared/utils/services/src/lib/global-http-error.interceptor';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: ['domainShell'],
    rehydrate: true,
    checkStorageAvailability: true,
  })(reducer);
}
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideStore({}, { metaReducers }),
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),

    provideEffects(),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi(), withFetch()),
    importProvidersFrom(SharedUtilsTranslateModule),
    provideAppInitializer(() => {
      const environmentService = inject(EnvironmentService);
      environmentService.setEnvironment(environment);
    }),

    providePrimeNG({
      theme,
    }),
    { provide: UrlHandlingStrategy, useClass: DomainUrlHandlingStrategy },
    ...(environment.production ? [] : [provideStoreDevtools({ maxAge: 25 })]),

    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpErrorInterceptor, multi: true },
    MessageService,

    {
      provide: EVENT_MANAGER_PLUGINS,
      useClass: CheckInvalidEventPlugin,
      multi: true,
    },
  ],
};
